import styled from "styled-components";

export const Panel = styled.div`
  width: 100%;
  height: 100%;
  overflow-x: visible;
`;

export const Title = styled.div`
  display: flex;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 33px;
  padding: 0 14px 0 0;
  text-transform: capitalize;

  span {
    margin-top: 6px;
  }

  gap: 16.43px;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 10px;
`;

export const ServiceName = styled.span`
  text-transform: none;
`;

export const TabRowWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
